import React, {useEffect} from "react";
import {IconDownloadExcel} from 'components/assets/icons';
import {BaseButton} from "./Button";
import {getLocalStorage} from "../../hooks/useLocalStorage";
import {exportExcelDownload, exportMergeExcelDownload, exportStyleExcelDownload} from "utils/file";
import {Checkbox} from "antd";

export function ExcelButton(
  {
    label = '엑셀 다운로드',
    isCheckComp = false,
    checkCompLabel = '엑셀 다운로드(체크박스)',
    headerList = [],
    gridList = [],
    filterList = [],
    renderList = [],
    checkRows = [],
    checkKey = '',
    fileName,
    isMergeHeader,
  }) {
  /*0. Variables*/
  const menu = getLocalStorage('openMenuInfo');

  /*1. Hook*/
  useEffect(() => {
  }, [])

  /* 2. Functions */
  /*2-1. Handle*/
  const fnExcelDownload = (isCheck) => {
    if (isMergeHeader) {
      fnMergeExcelDownload(isCheck)
      return
    }
    const headers = headerList.map(it => {
      if (!it.dataIndex || filterList.includes(it.dataIndex)) {
        return null
      }
      if (typeof it.title === 'object') {
        if (typeof it.title?.props?.children === 'string') {
          return it.title?.props?.children
        } else {
          return it.title?.props?.children?.filter(el => typeof el === 'string').join(" ")
        }
      }
      return it.title
    }).filter(el => el !== null)

    let data = gridList;
    if (isCheck) {
      if (!checkRows?.length) {
        alert('선택된 항목이 없습니다.');
        return;
      }
      data = data.filter(el => checkRows.includes(el[checkKey]))
    }
    // 데이터 변환 로직 수정
    const processData = data.map((el, idx) => {
      const obj = {};
      headerList.forEach((h) => {
        if (!h.dataIndex || filterList.includes(h.dataIndex)) {
          return; // 스킵
        }

        let cellValue;
        const findRender = renderList.find(r => r.dataIndex === h.dataIndex)
        if(findRender) {
          cellValue = findRender.render(el[h.dataIndex], el)
        }else if (h.render) {
          // render 함수로 데이터 렌더링
          cellValue = h.render(el[h.dataIndex], el, idx);
          // React 엘리먼트에서 텍스트 추출
          cellValue = extractTextFromReactElement(cellValue);
        } else {
          cellValue = el[h.dataIndex];
        }

        // 처리된 값을 obj에 추가
        obj[h.dataIndex] = cellValue;
      });
      return obj;
    });
    
    exportStyleExcelDownload(headers, processData, fileName || menu?.depth?.[1]);
  };

  const fnMergeExcelDownload = (isCheck) => {

    const headers = getMergeExcelHeaders(headerList)

    let data = gridList;
    if (isCheck) {
      if (!checkRows?.length) {
        alert('선택된 항목이 없습니다.');
        return;
      }
      data = data.filter(el => checkRows.includes(el[checkKey]))
    }

    const processData = data.map((el) => {
      const obj = {}
      headerList?.map(it => it.children?it.children:it) //children 이 없으면 해당 title,dataIndex를 가져오는 조건추가
        .reduce((acc, cur) => acc.concat(cur), []).forEach((h, idx) => {
        if (!h?.dataIndex || filterList.includes(h?.dataIndex)) {
          return true
        }

        let cellValue;
        const findRender = renderList.find(r => r.dataIndex === h.dataIndex)
        if(findRender) {
          cellValue = findRender.render(el[h.dataIndex], el)
        }else if (h.render) {
          // render 함수로 데이터 렌더링
          cellValue = h.render(el[h.dataIndex], el, idx);
          // React 엘리먼트에서 텍스트 추출
          cellValue = extractTextFromReactElement(cellValue);
        } else {
          cellValue = el[h.dataIndex];
        }

        // 처리된 값을 obj에 추가
        obj[h.dataIndex] = cellValue;
      });
      return obj
    });

    exportMergeExcelDownload(headers, processData, fileName || menu?.depth?.[1]);
  };

  /*2-2. Etc*/
  const getMergeExcelHeaders = (headerList) => {
    const result = [];

    // 1. 첫 번째 행: 각 그룹의 title을 추가
    const firstRow = [];
    headerList?.forEach(group => {
      firstRow.push(group.title);
      // 중간에 빈 칸을 추가: children의 갯수 - 1만큼 빈 문자열을 추가
      for (let i = 0; i < group.children?.length - 1; i++) {
        firstRow.push('');
      }
    });
    result.push(firstRow);

    // 2. 두 번째 행: 각 그룹 내의 children.title을 추가
    const secondRow = [];
    headerList?.forEach(group => {
      if(group.children){
        group.children?.forEach(child => secondRow.push(child.title))
      }else{
          secondRow.push('') //children 이 없는 헤더가 섞여있을때 빈값 추가
      }
    });
    result.push(secondRow);

    return result;
  }

  // React 엘리먼트에서 텍스트를 재귀적으로 추출하는 함수
  const extractTextFromReactElement = (element) => {
    if (!element) return '';
    if (typeof element === 'string' || typeof element === 'number') {
      return element.toString(); // 기본 텍스트 반환
    }
    if (Array.isArray(element)) {
      return element.map(extractTextFromReactElement).join(' '); // 배열 처리
    }
    if (React.isValidElement(element)) {
      // 특정 컴포넌트 타입을 처리
      if (element.type === Checkbox) {
        return element.props.checked ? 'O' : 'X'; // Checkbox 상태 반환
      }
      return extractTextFromReactElement(element.props.children); // React 엘리먼트의 children 순회
    }
    return '';
  };

  /*3. Jsx*/
  return (
    <>
      <BaseButton padding={'4px 0px'} label={label} text icon={<IconDownloadExcel/>} onClick={fnExcelDownload}/>
      {
        isCheckComp
          ? <BaseButton padding={'4px 0px'} label={checkCompLabel} text icon={<IconDownloadExcel/>}
                        onClick={() => fnExcelDownload(true)}/>
          : null
      }
    </>
  );
}